module.exports = __webpack_public_path__ + "img/submit-request.c845f158.png";